export default "__VITE_ASSET__DZtTKyag__"